import {
  AddressLocationType,
  CreateAccountAddressInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationHook } from '~/shared/providers/api';

export const useCreateAccountAddressMutation = createMutationHook(
  'transportation.accountAddressCreate',
  (params: {
    accountId: string;
    name: string;
    address: CreateAccountAddressInput['address'];
    locationType?: AddressLocationType;
  }) => ({
    crmAccountAddressCreate: {
      __args: {
        input: {
          name: params.name,
          address: params.address,
          accountId: params.accountId,
          locationType: params.locationType ?? 'Shipping',
        },
      },
      id: true,
    },
  }),
);
